export * from './timer.component'
